import React from "react";
import { func } from "prop-types";

import * as S from "./styled";

const TAB_ITEMS = [
  {
    text: "Buy",
    value: "buy"
  },
  {
    text: "Sell",
    value: "sell"
  }
];

const BuyerSellerSwitch = ({ onChangeValue }) => (
  <S.Input
    labelText="I want to"
    name="buy_sell"
    onChangeValue={onChangeValue}
    required
    tabItems={TAB_ITEMS}
    type="toggle"
  />
);

BuyerSellerSwitch.propTypes = {
  onChangeValue: func.isRequired
};

export default BuyerSellerSwitch;
